import { Fragment, FunctionComponent } from "react";
import { Helmet } from "react-helmet";
import Navigation from "../navigation/navigation";
import { StyledContents, StyledView } from "./view.styles";

interface ViewProps {
  children: any;
  title: string;
  description?: string;
  navigation?: boolean;
  hideTitle?: boolean;
  className?: string;
  noindex?: boolean;
}

const View: FunctionComponent<ViewProps> = ({
  children,
  title,
  description = "",
  navigation = true,
  className,
  noindex = false,
}) => {
  const HelmetComponent = Helmet as any;
  return (
    <Fragment>
      <HelmetComponent>
        <title>{title}</title>
        <meta name="description" content={description} key="description" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {noindex && <meta name="robots" content="noindex,follow" />}
      </HelmetComponent>
      <StyledView className={className}>
        {navigation && <Navigation />}
        <StyledContents role="main">{children}</StyledContents>
      </StyledView>
    </Fragment>
  );
};

export default View;
